import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { appActions } from '../../../../../store/modules/app';
import useCustomTable from '../../../../../hooks/common/useCustomTable';
import TableToolbar from '../../../../../components/table/TableToolbar';
import ReactTable from '../../../../../components/table/ReactTable';
import ReactTablePagination from '../../../../../components/table/ReactTablePagination';
import CsReviewListColumns from './CsReviewListColumns';
import { ContainerStyled, SectionStyled } from './CsReview.style';
import { FilterOption, PaginationOption, ReviewListResponseType } from '../../common/types/ReviewListType';

interface ICsReviewListProps {
  paginationOption: PaginationOption;
  sortOption: {
    sort: string;
  };
  reviewList: ReviewListResponseType | undefined;
  onChangeFilterOption: (e: { value: string; id: keyof FilterOption }) => void;
  onChangePaginationOption: (id: keyof PaginationOption, value: number) => void;
  onClickSortOption: (columnId: string, isMultiSortable: boolean) => void;
  onClickResetFilter: () => void;
  onClickExcelDownload: () => void;
  onClickDateRangeChange: (dateRange: { startDate: string; endDate: string }) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

const CsReviewList = (props: ICsReviewListProps): JSX.Element => {
  const {
    reviewList,
    sortOption,
    paginationOption,
    onChangePaginationOption,
    onChangeFilterOption,
    onClickSortOption,
    onClickResetFilter,
    onClickExcelDownload,
    onClickDateRangeChange,
    currentPage,
    setCurrentPage,
  } = props;

  const dispatch = useDispatch();

  const handleProductPreviewModal = useCallback(
    (data: { productId: number }) => {
      dispatch(appActions.getProductPreviewData(data));
    },
    [dispatch],
  );

  const columns = useMemo(
    () =>
      CsReviewListColumns({
        onChangeFilterOption,
        onClickDateRangeChange,
        handleProductPreviewModal,
      }),
    [onChangeFilterOption, onClickDateRangeChange],
  );

  const tableInstance = useCustomTable(columns, reviewList?.reviews);

  return (
    <ContainerStyled>
      <TableToolbar
        total={reviewList?.totalCount}
        hasUserCheckBox={false}
        hasFilter={true}
        hasExelDownloadButton={true}
        onClickExcelDownload={onClickExcelDownload}
        onClickResetFilter={onClickResetFilter}
      />
      <SectionStyled>
        <ReactTable
          tableInstance={tableInstance}
          onClickSortOption={onClickSortOption}
          sortOption={sortOption}
          isMultiSortable={true}
          emptyText="요청하신 검색 필터로 검색된 상품 후기 리스트가 없습니다."
        />
      </SectionStyled>
      <ReactTablePagination
        onChangePaginationOption={onChangePaginationOption}
        paginationOption={paginationOption}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        total={reviewList?.totalCount || 0}
      />
    </ContainerStyled>
  );
};

export default CsReviewList;
